import { render, staticRenderFns } from "./ActsList.vue?vue&type=template&id=f8c972f8&scoped=true&"
import script from "./ActsList.vue?vue&type=script&lang=js&"
export * from "./ActsList.vue?vue&type=script&lang=js&"
import style0 from "./ActsList.vue?vue&type=style&index=0&id=f8c972f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c972f8",
  null
  
)

export default component.exports